const NotificationEventType = {
    // ticket
    TICKET_NEW: 'TICKET_NEW',
    TICKET_UPDATE: 'TICKET_UPDATE',
    UPDATE_PIC:'UPDATE_PIC',
    TICKET_APPROVAL_REQUEST: 'TICKET_APPROVAL_REQUEST',
    TICKET_DEADLINE_REACHED: 'TICKET_DEADLINE_REACHED',
    TICKET_APPROVAL_IN_WORKFLOW: 'TICKET_APPROVAL_IN_WORKFLOW',
    TICKET_REJECT_IN_WORKFLOW: 'TICKET_REJECT_IN_WORKFLOW',
    CREATE_TICKET_TELEPHONE: 'CREATE_TICKET_TELEPHONE',

    // chat
    MESSAGE_NEW: 'MESSAGE_NEW',
    MESSAGE_UPDATE: 'MESSAGE_UPDATE',
    MESSAGE_STAMP_NEW: 'MESSAGE_STAMP_NEW',
    MESSAGE_ATTACHMENT_NEW: 'MESSAGE_ATTACHMENT_NEW',
    MESSAGE_REACTION: 'MESSAGE_REACTION',
    MESSAGE_MENTION_TO: 'MESSAGE_MENTION_TO',
    MESSAGE_MENTION_ALL: 'MESSAGE_MENTION_ALL',
    EXCEED_MAX_STORAGE:'EXCEED_MAX_STORAGE',
    KNOWLEDGE_CHAT_MESSAGE_NEW:'KNOWLEDGE_CHAT_MESSAGE_NEW',
    MENTION_IN_CHAT_KNOWLEDGE: 'MENTION_IN_CHAT_KNOWLEDGE',


    // user
    ADMIN_ON: 'ADMIN_ON',
    ADMIN_OFF: 'ADMIN_OFF',
    OWNER_ON: 'OWNER_ON',
    OWNER_OFF: 'OWNER_OFF',
    GENERAL_ON: 'GENERAL_ON',
    GENERAL_OFF: 'GENERAL_OFF',
    MEMBER_ON: 'MEMBER_ON',
    MEMBER_OFF: 'MEMBER_OFF',
    PM_ON: 'PM_ON',
    PM_OFF: 'PM_OFF',
    USER_TYPE_CHANGE: 'USER_TYPE_CHANGE',

    EXCEED_MAX_TICKET: 'EXCEED_MAX_TICKET',
    EXCEED_MAX_GENERAL_USER_WHEN_CREATE_TICKET: 'EXCEED_MAX_GENERAL_USER_WHEN_CREATE_TICKET',

    //Contract
    NOTI_UPDATE_CONTRACT_CREDIT_CARD: 'NOTI_UPDATE_CONTRACT_CREDIT_CARD',
    NOTI_UPDATE_CONTRACT_BANK_TRANSFER: 'NOTI_UPDATE_CONTRACT_BANK_TRANSFER',
    OVER_MAX_RESOURCES: 'OVER_MAX_RESOURCES',

    // Register org
    NOTI_ORG_REGISTERED_TRIAL: 'NOTI_ORG_REGISTERED_TRIAL',
    NOTI_ORG_STARTED_TRIAL: 'NOTI_ORG_STARTED_TRIAL',
    NOTI_YOURS_CONTRACT_HAVE_BEEN_UPDATED: 'NOTI-YOURS-CONTRACT-HAVE-BEEN-UPDATED'
};

export default NotificationEventType;